import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicCreateAccount = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              La création d'un compte Wodzone est simple et gratuite. Pour vous inscrire, rendez-vous sur wodzone.onrender.com
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">Vous pouvez créer un compte depuis un ordinateur, un navigateur mobile en utilisant l'une des options suivantes :</p>
              <ul>
                <li className="help-text pl-8 mb-16">Votre adresse e-mail</li>
              </ul>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part">{topic.subtitles[1]}</p>
              <p className="help-text">
                Après la création de votre compte, les informations essentielles sont renseignées. 
                Pour une expérience optimale, nous vous recommandons de renseigner sur votre<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personal-info`}>profil</a>votre numéro de téléphone, adresse postale ou tailles de vêtements. 
                Ces données seront pré-remplies pour vos futures inscriptions à des événements, pour vous ou vos coéquipiers.
              </p>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part">{topic.subtitles[2]}</p>
              <p className="help-text">Vous devez faire au préalable créer votre compte Wodzone, puis :</p> 
              <ul>
                <li className="help-text pl-8 mb-16">
                  Vous pouvez voir tous les détails pour devenir organisateurs sur<a target='_blank' className="link" rel="noopener noreferrer" href="https://wodzone.fr/">wodzone.fr</a>.
                </li>
                <li className="help-text pl-8 mb-16">
                  Nous<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>contacter</a>directement. Nous serons ravis de vous guidez étape par étape.
                </li>
              </ul>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part">{topic.subtitles[3]}</p>
              <p className="help-text">
                Si vous avez plusieurs comptes Wodzone, vous ne pouvez malheureusement pas les fusionner. Cependant, 
                vous pouvez supprimer le compte que vous utilisez le moins. En savoir plus sur la<a target='_blank' className="link" href="/topics/compte/12">
                marche à suivre si vous avez plusieurs comptes.</a>
              </p> 
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicCreateAccount